// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"554b9fe0","285":"868024e6","458":"82012616","774":"75971c47","787":"4cd9641e","851":"009b14ac","858":"4e8c1012","916":"59ab4500"}[chunkId] + ".chunk.js";
};